import(/* webpackMode: "eager", webpackExports: ["MarketingHeader"] */ "/vercel/path0/components/marketing/marketing-header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
